module.exports = __webpack_public_path__ + "static/media/downloadBlack.7d42027e.svg";